import * as React from "react";
import { Input as InputPrimitive } from "@base-ui/react/input";

import { cn } from "frontend-components/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
    return (
        <InputPrimitive
            type={type}
            data-slot="input"
            className={cn(
                "font-body text-text-primary placeholder:text-text-muted border-border-input hover:border-border-input-hover focus-visible:border-border-focus aria-invalid:border-chameleon-pink w-full min-w-0 rounded-none border bg-white px-3 py-2.5 text-base font-normal outline-none transition-[border-color] file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
                className,
            )}
            {...props}
        />
    );
}

export { Input };
